import script from "./MatchingConfetti.vue?vue&type=script&setup=true&lang=ts"
export * from "./MatchingConfetti.vue?vue&type=script&setup=true&lang=ts"

import "./MatchingConfetti.vue?vue&type=style&index=0&id=96c0fcae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96c0fcae"]])

export default __exports__